import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/toaster";

import Home from "./pages/Home";
import Products from "./pages/Products";
import Certificates from "./pages/Certificates";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";

import KVKK from "./pages/legal/KVKK";
import MesafeliSatis from "./pages/legal/MesafeliSatis";
import OnBilgilendirme from "./pages/legal/OnBilgilendirme";
import GizlilikPolitikasi from "./pages/legal/GizlilikPolitikasi";
import IadePolitikasi from "./pages/legal/IadePolitikasi";
import TeslimatPolitikasi from "./pages/legal/TeslimatPolitikasi";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/goomoreurunler" element={<Products />} />
          <Route path="/sertifikalar" element={<Certificates />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/sss" element={<FAQ />} />

          <Route
            path="/on-bilgilendirme-formu"
            element={<OnBilgilendirme />}
          />

          <Route path="/kvkk" element={<KVKK />} />

          <Route
            path="/mesafeli-satis-sozlesmesi"
            element={<MesafeliSatis />}
          />

          <Route
            path="/gizlilik-politikasi"
            element={<GizlilikPolitikasi />}
          />

          <Route
            path="/iade-politikasi"
            element={<IadePolitikasi />}
          />

          <Route
            path="/teslimat-politikasi"
            element={<TeslimatPolitikasi />}
          />
        </Routes>

        <Footer />
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;